<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    data() {
            return {
                homePath: ''
            }
        },
        methods: {
            goHome() {
                if (localStorage.getItem('cid') == '1992') {
                    window.location.href = "http://101.200.234.55:8080/cimdr/index.html";
                } else {
                    this.$router.push(this.homePath);
                }
            }
        },
        mounted() {
            let homePath = localStorage.getItem('homePath');
            this.homePath = homePath;
        }
}
</script>
<style>
.content {
    width: 950px;
    height: 100%;
    margin: 0 auto;
}

.line {
    height: 1px;
    background-color: #999;
    margin-top: 5px;
}

.idx_title {
    color: #000;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
}

.s_title {
    color: #359ED8;
    font-size: 20px;
    font-weight: 500;
}

.fx {
    font-size: 20px;
    color: #000;
    padding: 0 5px;
    font-weight: 500;
}

.footer {
    margin-top: 100px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// o_index.vue?07f8c766